<ng-container *ngIf="abierto">
    <div class="divisor16"></div>
    <div>
        <div [hidden]="consulta" class="evaluacion">
            <div class="row">
                <div class="col-lg-12" style="padding: 0px;">
                    <section>
                        <div *ngIf="accion.accionid == 1">
                            <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="listaevaluador"
                            [noDataText]="'Sin Datos'"
                            [showColumnHeaders]="true"
                            >
                            <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>

                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>

                            <dxi-column
                                dataField="nombre"
                                caption="Persona que lo evalúa">
                            </dxi-column>
                            <dxi-column
                                dataField="relacion"
                                caption="Relacion">
                            </dxi-column>
                            <dxi-column
                                dataField="departamento"
                                caption="Departamento">
                            </dxi-column>
                            <dxi-column
                                dataField="puesto"
                                caption="Puesto">
                            </dxi-column>

                            </dx-data-grid>
                         </div>
                        <div *ngIf="accion.accionid != 1">
                            <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="listaevaluador"
                            [noDataText]="'Sin Datos'"
                            [showColumnHeaders]="true"
                            >
                            <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>

                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>

                            <dxi-column
                                dataField="alumno"
                                caption="Persona que lo evalúa">
                            </dxi-column>
                            <dxi-column
                                dataField="relacion"
                                caption="Relacion">
                            </dxi-column>
                            <dxi-column
                                dataField="nivel"
                                caption="Nivel">
                            </dxi-column>
                            <dxi-column
                                dataField="grado"
                                caption="Grado">
                            </dxi-column>
                            <dxi-column
                                dataField="grupo"
                                caption="Grupo">
                            </dxi-column>
                            <dxi-column
                                dataField="materia"
                                caption="Materia o Taller">
                            </dxi-column>
                            </dx-data-grid>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</ng-container>
